import React, { useState } from "react";
import Select from "react-select";
import axiosInstance from "../../../../../axiosInterceptor";
import { toast } from "react-toastify";
import InvoiceDownloadBtn from "../../../InvoiceDownloadBtn";

const orderStatusOptions = [
  { value: "PENDING", label: "Pending" },
  { value: "PROCESSING", label: "Processing" },
  { value: "CONFIRMED", label: "Confirmed" },
  { value: "DELIVERED", label: "Delivered" },
  { value: "CANCELLED", label: "Cancelled" },
  { value: "PARTIALLY_DELIVERED", label: "Partially Delivered" },
];

const paymentStatusOptions = [
  { value: "PROCESSING", label: "Processing" },
  { value: "SUCCESS", label: "Success" },
  { value: "CANCELLED", label: "Cancelled" },
  { value: "PENDING", label: "Pending" },
  { value: "REFUNDED", label: "Refunded" },
];

const OrderPaymentStatusCard = ({
  orderId,
  currentOrderStatus,
  currentPaymentStatus,
  fetchOrderDetail,
  data
}) => {
  const [selectedOrderStatus, setSelectedOrderStatus] = useState(currentOrderStatus);
  const [selectedPaymentStatus, setSelectedPaymentStatus] = useState(currentPaymentStatus);
 const [loadingType, setLoadingType] = useState(null);
  const handleUpdateStatuses = async (sendMail) => {
   const type = sendMail ? "withMail" : "withoutMail";
  setLoadingType(type);
    try {
      if (
        selectedOrderStatus === currentOrderStatus &&
        selectedPaymentStatus === currentPaymentStatus
      ) {
        toast.info("No changes detected");
        return;
      }

      const response = await axiosInstance.put(
        `/order/status/${orderId}`, 
        {
          orderStatus: selectedOrderStatus,
          paymentStatus: selectedPaymentStatus,
          isMailSend: sendMail,
        }
      );

      toast.success(response.data?.message || "Statuses updated successfully");
      fetchOrderDetail(orderId); 
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong");
    } finally {
    setLoadingType(null);
  }
  };

  return (
    <div className="col-md-12 mt-5">
      <div className="card shadow-sm border-0">
        <div className="card-body">
          <h5 className="mb-4 fw-bold">Update Order & Payment Status</h5>
          <div className="row g-4">
            <div className="col-md-6">
              <label className="form-label fw-semibold">Order Status</label>
              <Select
                options={orderStatusOptions}
                value={orderStatusOptions.find(opt => opt.value === selectedOrderStatus)}
                onChange={option => setSelectedOrderStatus(option ? option.value : "")}
                isClearable
                placeholder="Select Order Status"
              />
            </div>

            <div className="col-md-6">
              <label className="form-label fw-semibold">Payment Status</label>
              <Select
                options={paymentStatusOptions}
                value={paymentStatusOptions.find(opt => opt.value === selectedPaymentStatus)}
                onChange={option => setSelectedPaymentStatus(option ? option.value : "")}
                isClearable
                placeholder="Select Payment Status"
              />
            </div>
          </div>

          <div
  className="mt-4 d-flex justify-content-center align-items-center flex-wrap"
  style={{ gap: "10px" }}
>
  <button
    type="button"
    className="status-action-btn btn-save-mail"
    onClick={() => handleUpdateStatuses(true)}
    disabled={loadingType === "withMail"}
  >
    {loadingType === "withMail"
      ? "Updating..."
      : "Save & Send Mail"}
  </button>

  <button
    type="button"
    className="status-action-btn btn-save"
    onClick={() => handleUpdateStatuses(false)}
    disabled={loadingType === "withoutMail"}
  >
    {loadingType === "withoutMail"
      ? "Updating..."
      : "Save Without Mail"}
  </button>

  <InvoiceDownloadBtn data={data} />
</div>
        </div>
      </div>
    </div>
  );
};

export default OrderPaymentStatusCard;
